/**
 * CalendarUserIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CalendarUserIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M16.5 2.1a.9.9 0 0 1 .9.9v.6h.6a3.9 3.9 0 0 1 3.9 3.9V9a.9.9 0 0 1-1.8 0V7.5A2.1 2.1 0 0 0 18 5.4h-.6V6a.9.9 0 0 1-1.8 0v-.6H8.4V6a.9.9 0 0 1-1.8 0v-.6H6a2.1 2.1 0 0 0-2.1 2.1V18c0 1.16.94 2.1 2.1 2.1h5a.9.9 0 0 1 0 1.8H6A3.9 3.9 0 0 1 2.1 18V7.5A3.9 3.9 0 0 1 6 3.6h.6V3a.9.9 0 1 1 1.8 0v.6h7.2V3a.9.9 0 0 1 .9-.9m3.409 15a3 3 0 0 1 2.991 2.994V21a.9.9 0 0 1-1.8 0v-.904a1.2 1.2 0 0 0-1.194-1.196h-2.81a1.2 1.2 0 0 0-1.196 1.194V21a.9.9 0 0 1-1.8 0v-.909a3 3 0 0 1 2.994-2.991zM7.5 14.625l.132.006a1.375 1.375 0 1 1-.132-.006m5 0 .132.006a1.375 1.375 0 1 1-.132-.006m6-3.775a2.9 2.9 0 1 1 0 5.8 2.9 2.9 0 0 1 0-5.8m0 1.8a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2m-11-2.025.132.006a1.375 1.375 0 1 1-.132-.006m5 0 .132.006a1.375 1.375 0 1 1-.132-.006" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const CalendarUserIcon = makeIcon('CalendarUserIcon', CalendarUserIconSvg)
